import { styled } from '@mui/material/styles'

import { GridWrapper } from '../../wrapper'

export const GridBody = styled( GridWrapper )(( props ) => ({
  backgroundColor: props.theme.palette.background.default,
  borderRadius: 2,
  margin: '5px',
}))
